import React                          from 'react';
import classnames                     from 'classnames';
import { silkscreenSide as options } from 'pu-data/SelectOptions';
import { silkscreen as tooltip }      from 'pu-data/Tooltips';
import SelectComponent                from './SelectComponent';

const SilkscreenColor = (props) => {
  const name = props.name;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={onChange}
      options={props.options}
      tooltip={props.tooltip}
      selected={props.parameters[name]}
      groupName={props.groupName}
      className={classnames('silkscreen-color', props.className)} />
  );
};

SilkscreenColor.defaultProps = {
  label   : 'Silkscreen Sides',
  name    : 'silkscreen_sides',
  required: true,
  options,
  tooltip,
};

export default SilkscreenColor;
